import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core'
import { Router } from '@angular/router'
import {
  ApiService,
  Appointment,
  AppointmentModel,
  eligibilityDisplayStatus,
  eligibilityStatusColor,
  getEligibilityStatusText, intakeStatusColor, intakeStatusText,
  Patient,
} from '@mmx/shared'
import { TranslateService } from '@ngx-translate/core'
import { cloneDeep } from 'lodash'
import { BehaviorSubject } from 'rxjs'

@Component({
  selector: 'mmx-eligibility-status-icon',
  templateUrl: 'eligibility-status-icon.component.html',
  styleUrls: ['eligibility-status-icon.component.scss'],
  standalone: false,
})
export class EligibilityStatusIconComponent implements OnInit, OnChanges {
  @Input() patient?: Patient
  @Input() appointment?: AppointmentModel
  @Input() status?: Appointment.ELIGIBILITY_STATUS
  @Input() workflow = false

  public inProgress = false
  public tooltipText$ = new BehaviorSubject<string>('')
  public ELIGIBILITY_STATUS = Appointment.ELIGIBILITY_STATUS
  public eligibilityDisplayStatus = eligibilityDisplayStatus
  public eligibilityStatusColor = eligibilityStatusColor

  public constructor(
    private router: Router,
    private api: ApiService,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.updateTooltip()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.appointment && !changes.appointment.firstChange) {
      this.updateTooltip()
    }
  }

  goto(...commands: string[]) {
    this.router.navigate(commands)
  }

  isActive(status: Appointment.ELIGIBILITY_STATUS): boolean {
    return [
      Appointment.ELIGIBILITY_STATUS.ACTIVE,
      Appointment.ELIGIBILITY_STATUS.AVOIDED,
    ].includes(status)
  }

  markInsuranceAs(
    type: 'primary' | 'secondary',
    updateStatus: 'active' | 'inactive',
  ): void {
    this.inProgress = true
    const status =
      updateStatus === 'active'
        ? Appointment.ELIGIBILITY_STATUS.AVOIDED
        : Appointment.ELIGIBILITY_STATUS.INACTIVE
    const eligibilityDetails = cloneDeep(this.appointment.eligibilityDetails)
    eligibilityDetails[type] = {
      id: '',
      status,
    }
    this.api
      .patchAppointment(this.appointment.id, {
        eligibilityDetails,
      })
      .subscribe({
        next: (appointment) => {
          this.appointment.eligibilityDetails = appointment.eligibilityDetails
          this.updateTooltip()
          this.inProgress = false
        },
        error: () => {
          this.inProgress = false
        },
      })
  }

  private updateTooltip(): void {
    this.tooltipText$.next(
      this.translateService.instant('common.primary') +
        ': ' +
        this.translateService.instant(
          getEligibilityStatusText(this.appointment?.eligibilityPrimaryStatus),
        ) +
        (this.appointment?.eligibilitySecondaryStatus
          ? '\n' +
            this.translateService.instant('common.secondary') +
            ': ' +
            this.translateService.instant(
              getEligibilityStatusText(
                this.appointment?.eligibilitySecondaryStatus,
              ),
            )
          : ''),
    )
  }

  protected readonly intakeStatusColor = intakeStatusColor
  protected readonly intakeStatusText = intakeStatusText
}
